module.exports = __webpack_public_path__ + "img/steam-bg.4c048faf.png";